import { Modal, message } from 'antd';
import React, { useEffect, useState } from 'react';
import './index.scss';
import cls from 'classnames';
import logo1 from '@/assets/images/desktop/common/logo1.png';
import code_icon from '@/assets/images/desktop/common/saoyisao.png';
import code_img from '@/assets/images/desktop/common/code_img.png';
import Default from '@/assets/images/desktop/common/default.jpg';
import arrow1 from '@/assets/images/desktop/common/right_arrow1.png';
import arrow2 from '@/assets/images/desktop/common/right_arrow2.png';
import arrow3 from '@/assets/images/desktop/common/right_arrow3.png';
import { queryInstanceDetails, downloadInstanceShowImage } from '../../../shared/api';
import { htmltoStr } from '../../../../utils';
import * as d3 from 'd3';
import $ from 'jquery';
// import html2canvas from './html2canvas.min.js';
const pre = window.ENV_IMG_PREURL_SRC;

const ShareModal = ({ visible, time, operationType, instanceId, fileInfoId, startNodeName, endNodeName, active, list }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [instance, setInstance] = useState();
  const [url, setUrl] = useState();
  const [name, setName] = useState();
  let d3Canvas = {
    edges: null,  // 线元素组合的初始化
    links: null,  // 线初始化
    rects: null,  // 关系文字背景框初始化
    texts: null,  // 关系名称初始化
    circles: null,  // 实例节点圆形初始化
    circleTexts: null,  // 实例节点文字初始化
    relationRects: null,  // 关系节点矩形框初始化
    relationRectTexts: null,  // 关系节点文字初始化
  }
  const centerRadius = 36;  // 中心节点半径
  const normalRadius = 30;  // 普通节点半径
  const [renderData, setRenderData] = useState();
  useEffect(() => {
    setIsModalOpen(visible);
    // 知识百科、影像探索:查询实例详情
    if (operationType == 1 || operationType == 2) {
      queryInstanceDetails({
        instanceId: instanceId
      }).then(res => {
        if (res) {
          setInstance(res)
        }
      });
    } else {
      if (active || active === 0) {
        setTimeout(() => {
          $('#graph').empty();
          initMap(list[active]);
        }, 0);
      }
    }
    // 获取分享的地址、标题
    let url1 = window.locationPre;
    let name1 = '';
    if (operationType == 1) {
      url1 += '/Subject/null/' + instanceId;
      name1 = '知识百科';
    }
    if (operationType == 2) {
      url1 += "/PicturelistPage/" + instanceId + '?fileInfoId=' + fileInfoId;
      name1 = '影像探索';
    }
    if (operationType == 3) {
      url1 += '/Relation?startsearch=' + encodeURIComponent(startNodeName) + '&endsearch=' + encodeURIComponent(endNodeName);
      name1 = '关系路径';
    }
    setUrl(url1);
    setName(name1);
  }, [visible, time])

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // 复制链接
  const copy = () => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', url);
    input.setAttribute('id', 'inputCopy');
    input.select();
    document.execCommand('copy');
    let target = document.getElementById('inputCopy');
    document.body.removeChild(target);
    message.success('复制成功！');
  }

  const dataURLtoFile = (dataStr, mimeType) => {
    let bstr = atob(dataStr);
    let n = bstr.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mimeType });
  }

  // 下载图片
  const download = () => {
    downloadInstanceShowImage(instanceId).then(res => {
      let blob = dataURLtoFile(res.base64,'image/png');
      const link = document.createElement('a')
      let fileName = decodeURIComponent(instance?.instanceName)
      link.style.display = 'none'
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      setTimeout(() => {
        document.body.removeChild(link)
      }, 0);
    })
    // let getPixelRatio = function (context) { // 获取设备的PixelRatio
    //   let backingStore = context.backingStorePixelRatio ||
    //     context.webkitBackingStorePixelRatio ||
    //     context.mozBackingStorePixelRatio ||
    //     context.msBackingStorePixelRatio ||
    //     context.oBackingStorePixelRatio ||
    //     context.backingStorePixelRatio || 0.5;
    //   return (window.devicePixelRatio || 0.5) / backingStore;
    // };
    // let dataURIToBlob = function (imgName, dataURI, callback) {
    //   let binStr = atob(dataURI.split(',')[1]);
    //   let len = binStr.length;
    //   let arr = new Uint8Array(len);

    //   for (let i = 0; i < len; i++) {
    //     arr[i] = binStr.charCodeAt(i);
    //   }

    //   callback(imgName, new Blob([arr]));
    // }

    // let callback = function (imgName, blob) {
    //   let triggerDownload = $("<a>").attr("href", URL.createObjectURL(blob)).attr("download", imgName).appendTo("body").on("click", function () {
    //     if (navigator.msSaveBlob) {
    //       return navigator.msSaveBlob(blob, imgName);
    //     }
    //   });
    //   triggerDownload[0].click();
    //   triggerDownload.remove();
    // };
    // // 生成的图片名称
    // let imgName = "cs.jpg";
    // let shareContent = document.getElementById("contentModule");
    // let width = shareContent.offsetWidth;
    // let height = shareContent.offsetHeight;
    // let canvas = document.createElement("canvas");
    // let context = canvas.getContext('2d');
    // let scale = getPixelRatio(context); 
    // canvas.width = width * scale;
    // canvas.height = height * scale;
    // canvas.style.width = width + 'px';
    // canvas.style.height = height + 'px';
    // context.scale(scale, scale);

    // let opts = {
    //   // scale: scale,
    //   allowTaint: true,
    //   useCORS: true,
    //   canvas: canvas,
    //   width: width,
    //   height: height,
    //   dpi: window.devicePixelRatio,
    //   scrollY:0,
    //   scrollX:0
    // };
    // html2canvas(shareContent, opts).then(function (canvas) {
    //   context.imageSmoothingEnabled = false;
    //   context.webkitImageSmoothingEnabled = false;
    //   context.msImageSmoothingEnabled = false;
    //   context.imageSmoothingEnabled = false;
    //   let dataUrl = canvas.toDataURL('image/jpeg', 1.0);
    //   dataURIToBlob(imgName, dataUrl, callback);
    // });
  }

  // qq分享
  const shareqq = () => {
    const param = {
      url: url,
      desc: '',
      title: '徽州古建筑——' + name + '分享'
    };
    let s = [];
    const keys = Object.keys(param);
    keys.forEach(i => {
      s.push(i + '=' + encodeURIComponent(param[i] || ''));
    })
    // 跳转页面方式
    let targetUrl = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" + s.join('&');
    window.open(targetUrl, '_blank');
  }

  // 微博分享
  const shareweibo = () => {
    const param = {
      url: url,
      type: '3',
      title: '徽州古建筑' + name + '分享',
      rnd: new Date().valueOf()
    }
    let temp = [];
    const keys = Object.keys(param);
    keys.forEach(i => {
      temp.push(i + '=' + encodeURIComponent(param[i] || ''))
    })
    // 跳转页面方式
    let targetUrl = "https://service.weibo.com/share/share.php?" + temp.join('&');
    window.open(targetUrl, '_blank');
  }

  // 渲染关系图
  const renderRelationDraw = (res) => {
    let graphData = {
      'nodes': res.nodes,
      'links': res.relationships,
    }
    // 存储图谱数据
    setRenderData(graphData);
    // 清除力导向图
    emptyMapDatas();
    // 重新绘制力导向图
    let nodes = res.nodes.map(d => Object.create(d));
    res.relationships.forEach(d => {
      d['source'] = d['startNodeId'];
      d['target'] = d['endNodeId'];
    });
    let links = res.relationships.map(d => Object.create(d));
    showMap(nodes, links, false);
  };

  // 初始化图谱信息
  const initMap = (res) => {
    // 图谱放大缩小
    d3.select("#graph")
      .call(d3.zoom().scaleExtent([1 / 2, 4]).on("zoom", zoomed))
      .on('dblclick.zoom', null);    // 取消双击放大事件

    // 创建画布
    let svgBox = d3.select("#graph").append("svg")
      .attr("class", "svg")
      .append("g")
      .attr("class", "svgBox");
    // 箭头和图像初始化
    svgBox.append("defs").attr("class", "arrows");
    svgBox.append("defs").attr("class", "avatars");
    // 其他元素初始化
    svgBox.append("g").attr("class", "relMap_g");
    renderRelationDraw(res)
  }

  // 显示知识图谱方法
  const showMap = (nodes, links, isCenterSearch) => {
    console.log(nodes, links);
    // 获取搜索的节点名称
    let searchNames = [startNodeName, endNodeName];
    // 获取实例节点
    let nodes1 = nodes.filter(item => item.labels.indexOf('InstanceNode') >= 0);
    // 获取关系名称节点
    let nodes2 = nodes.filter(item => item.labels.indexOf('Relation') >= 0);
    let forceConfig = isCenterSearch ? [100, 50] : [100, 120];
    // 画布的宽高
    let width = $('#graph').width();
    let height = $('#graph').height();
    let simulation = d3.forceSimulation(nodes)
      .force("link", d3.forceLink(links).id(d => d.id))
      .force("center", d3.forceCenter(width / 2, height / 2))
      .force("charge", d3.forceManyBody().strength(-1600))
      .force("link", d3.forceLink(links).distance(forceConfig[0]))
      .force("collision", d3.forceCollide(forceConfig[1]))
      .force("x", d3.forceX())
      .force("y", d3.forceY());
    let relMap_g = d3.select('#graph').select('g.relMap_g');
    // 关系路径检索才需要绘制箭头
    if (!isCenterSearch) {
      d3.select('#graph').select("defs.arrows").selectAll(".linkMarker")
        .data(links)
        .enter()
        .append("marker")
        .attr("class", "linkMarker")
        .attr('id', function (d) {
          return "marker-" + d.properties.uuid;
        })
        .attr("markerWidth", 20)
        .attr("markerHeight", 20)
        .attr("refX", 70)
        .attr("refY", 6)
        .attr("orient", "auto")
        .attr("markerUnits", "userSpaceOnUse")
        .append("path")
        .attr("d", "M 0 0 12 6 0 12Z")
        .attr("fill", '#999999');
    }
    // 绘制节点图像
    // 绘制图片的容器
    let imgPatterns = d3.select('#graph').select("defs.avatars").selectAll(".nodeImg")
      .data(nodes1)
      .enter()
      .append("pattern")
      .attr("class", "nodeImg")
      .attr("id", function (d, index) {
        return 'avatar' + d.properties.nodeId;
      })
      // 两个取值userSpaceOnUse  objectBoundingBox
      .attr('patternUnits', 'objectBoundingBox')
      // <pattern>，x、y值的改变决定图案的位置，宽度、高度默认为pattern图案占填充图形的百分比。
      .attr("x", "10")
      .attr("y", "10")
      .attr("width", "5")
      .attr("height", "5");
    // 插入新节点的圆形背景
    imgPatterns
      .append("circle")
      .attr("fill", function (d) {
        return "#3F6B81";
      })
      .attr("r", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
      .attr("cx", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
      .attr("cy", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
    // 插入新节点的文物图片
    imgPatterns.append("image")
      .attr("class", "image")
      .attr("xlink:href", function (d) {
        let files = d.properties.files;
        if (files && files.length > 0) {
          let items = files.filter(el => el.fileCategory == 'FILE_TYPE_PICTURE');
          if (items.length > 0) {
            return pre + '/' + items[0].fileThumbnail;
          } else {
            return Default;
          }
        } else {
          return Default;
        }
      })
      .attr("height", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius * 2 : normalRadius * 2;
      })
      .attr("width", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius * 2 : normalRadius * 2;
      })
      .attr("preserveAspectRatio", "xMidYMin slice");

    // 每条线是个容器，有线 和一个装文字的容器
    d3Canvas.edges = relMap_g
      .selectAll("g.edge")
      .data(links)
      .enter()
      .append("g")
      .attr("class", function (d) {
        return "edges edge" + d.id;
      })
      .attr("transform", function (d) {
        return getTransform(d.source, d.target, getDis(d.source, d.target))
      });
    // 添加线
    d3Canvas.links = d3Canvas.edges.append("path")
      .attr("class", "links")
      .attr('stroke-dasharray', function (d) {
        if (d.type == 'attribute' || d.type == 'Tag') {
          return '2 4'
        }
      })
      .attr("d", d => {
        return "M" + 0 + "," + 0 + " L" + getDis(d.source, d.target) + ",0";
      })
      .style("marker-end", function (d) {
        return "url(#marker-" + d.properties.uuid + ")";
      })
      .attr('stroke', (d) => {
        return '#999999';
      })
      .attr("stroke-width", function (d) {
        return '1';
      });
    // 关系路径检索时才需要绘制关系名称
    if (!isCenterSearch) {
      // 添加关系文字的容器
      let rect_g = d3Canvas.edges.append("g")
        .attr("class", "rect_g")
        .on("click", function (d) {
          // console.log(d);
        });
      // 添加rect
      d3Canvas.rects = rect_g.append("rect")
        .attr("y", -10)
        .attr("height", 20)
        .attr("id", function (d) {
          return 'linkRect-' + d.properties.uuid
        })
        .attr("fill", function (d) {
          return '#838383'
        })
        .attr("rx", '10')
        .attr("ry", '15')

      // 关系名称  坐标（x,y）代表 文本的左下角的点
      d3Canvas.texts = rect_g.append("text")
        .attr("text-anchor", "middle") // <text>文本中轴对齐方式居中  start | middle | end
        .style("font-size", function (d) {
          return 12
        })
        .attr("id", function (d) {
          return 'linkText-' + d.properties.uuid
        })
        .text(d => {
          return d.properties.relationshipName
        })
        .attr("fill", function (d) {
          return '#f2f2f2'
        })
        .attr("y", function (d) {
          return 5
        })
        .attr("x", function (d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let bbox = d3.select(this).node().getBBox();
          let width = bbox.width;
          $(this).prev('rect').attr('width', width + 10);
          // 7.3.2 更新 text 的位置
          return getDis(d.source, d.target) / 2
        })
        .attr("transform", function (d) {
          // 7.3.3 更新文本反正
          if (d.target.x < d.source.x) {
            let x = getDis(d.source, d.target) / 2;
            return 'rotate(180 ' + x + ' ' + 0 + ')';
          } else {
            return 'rotate(0)';
          }
        });
    }
    // 绘制实例节点的圆形
    d3Canvas.circles = relMap_g.selectAll("circle.circles")
      .data(nodes1)
      .enter()
      .append("circle")
      .attr("class", function (d) {
        return 'circles circle' + d.properties.nodeId;
      })
      .style("cursor", "pointer")
      .attr("fill", function (d) {
        return ("url(#avatar" + d.properties.nodeId + ")");
      })
      .attr("stroke", function (d) {
        return '#9A7B79';
      })
      .attr("stroke-width", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? 10 : 0;
      })
      .attr("r", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? centerRadius : normalRadius;
      })
      .attr("cx", function (d) {
        return d.x;
      })
      .attr("cy", function (d) {
        return d.y;
      })
      // 鼠标单击
      .on('click', function (event, d) {
        console.log(d);
      })
      .on('mouseenter', function (event, d) {
        const nodeName = d.properties.nodeName;
        d3.select('#graph').select('.circleText' + d.properties.nodeId).text(nodeName);
      })
      .on('mouseleave', function (event, d) {
        const nodeName = d.properties.nodeName.length > 5 ? d.properties.nodeName.slice(0, 5) + '...' : d.properties.nodeName;
        d3.select('#graph').select('.circleText' + d.properties.nodeId).text(nodeName);
      })
      .call(drag(simulation));
    // 绘制实例节点的文字
    d3Canvas.circleTexts = relMap_g.selectAll("text.circleTexts")
      .data(nodes1)
      .enter()
      .append("text")
      .attr("class", function (d) {
        return 'circleTexts circleText' + d.properties.nodeId;
      })
      .attr('font-size', 13)
      .style('fill', function (d) {
        return "#333333";
      })
      .attr("dominant-baseline", "middle")
      .attr("text-anchor", "middle")
      .text(function (d) {
        return (d.properties.nodeName.length > 5 ? d.properties.nodeName.slice(0, 5) + '...' : d.properties.nodeName);
      })
      .attr("x", function (d) {
        return d.x;
      })
      .attr("y", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? d.y + centerRadius + 20 : d.y + normalRadius + 18;
      })
      .on('mouseenter', function (event, d) {
        const nodeName = d.properties.nodeName;
        d3.select('#graph').select('.circleText' + d.properties.nodeId).text(nodeName);
      })
      .on('mouseleave', function (event, d) {
        const nodeName = d.properties.nodeName.length > 5 ? d.properties.nodeName.slice(0, 5) + '...' : d.properties.nodeName;
        d3.select('#graph').select('.circleText' + d.properties.nodeId).text(nodeName);
      });
    // 中心节点检索才需要绘制关系节点
    if (isCenterSearch) {
      let relationNodes = relMap_g.selectAll('g.relationNodes')
        .data(nodes2)
        .enter()
        .append("g")
        .style("cursor", "pointer")
        .attr("class", "relationNodes")
        .call(drag(simulation));
      // 绘制关系节点的矩形
      d3Canvas.relationRects = relationNodes
        .append("rect")
        .attr("class", function (d) {
          return 'relationRects';
        })
        .attr("fill", '#838383')
        .attr("height", 24)
        .attr("y", function (d) {
          return d.y - 13;
        })
        .attr("rx", 15)
        .attr("ry", 15);
      // 绘制关系节点的文字
      d3Canvas.relationRectTexts = relationNodes
        .append("text")
        .attr('class', 'relationRectTexts')
        .attr('font-size', 13)
        .style('fill', function (d) {
          return "#f2f2f2";
        })
        .attr("dominant-baseline", "middle")
        .attr("text-anchor", "middle")
        .text(function (d) {
          return d.properties.nodeName;
        })
        .attr("x", function (d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let textArea = $(this)[0].getBoundingClientRect();
          let width = textArea.width;
          $(this).prev('rect').attr('width', width + 30);
          $(this).prev('rect').attr('x', d.x - (width + 30) / 2);
          // 7.3.2 更新 text 的位置
          return d.x
        })
        .attr("y", function (d) {
          return d.y;
        });
    }
    // 图谱显示位置
    simulation.on("tick", () => {
      updateMapLocation(searchNames, isCenterSearch);
    });
  }
  // 更新图谱位置方法
  const updateMapLocation = (searchNames, isCenterSearch) => {
    // 足够稳定时，才渲染一次
    d3Canvas.circles
      .attr("cx", function (d) {
        return d.x;
      })
      .attr("cy", function (d) {
        return d.y;
      })
    d3Canvas.circleTexts
      .attr("x", function (d) {
        return d.x;
      })
      .attr("y", function (d) {
        return searchNames.indexOf(d.properties.nodeName) >= 0 ? d.y + centerRadius + 20 : d.y + normalRadius + 18;
      })
    // 中心节点检索时才需要考虑关系节点
    if (isCenterSearch) {
      d3Canvas.relationRects
        .attr("y", function (d) {
          return d.y - 13;
        });
      d3Canvas.relationRectTexts
        .attr("x", function (d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let textArea = $(this)[0].getBoundingClientRect();
          let width = textArea.width;
          $(this).prev('rect').attr('width', width + 20);
          $(this).prev('rect').attr('x', d.x - (width + 20) / 2);
          // 7.3.2 更新 text 的位置
          return d.x
        })
        .attr("y", function (d) {
          return d.y;
        });
    }
    // 关系路径检索时才需要考虑连线上的关系名称容器
    else {
      d3Canvas.rects
        .attr("x", function (d) {
          return getDis(d.source, d.target) / 2 - $(this).attr('width') / 2
        }) // x 坐标为两点中心距离减去自身长度一半
      d3Canvas.texts
        .attr("x", function (d) {
          // 7.3.1 根据字的长度来更新兄弟元素 rect 的宽度
          let bbox = d3.select(this).node().getBBox();
          let width = bbox.width;
          $(this).prev('rect').attr('width', width + 10);
          // 7.3.2 更新 text 的位置
          return getDis(d.source, d.target) / 2
        })
        .attr("transform", function (d) {
          // 7.3.3 更新文本反正
          if (d.target.x < d.source.x) {
            let x = getDis(d.source, d.target) / 2;
            return 'rotate(180 ' + x + ' ' + 0 + ')';
          } else {
            return 'rotate(0)';
          }
        });
    }
    d3Canvas.links
      .attr("d", d => {
        return "M" + 0 + "," + 0 + " L" + getDis(d.source, d.target) + ",0";
      })
    d3Canvas.edges
      .attr("transform", function (d) {
        return getTransform(d.source, d.target, getDis(d.source, d.target))
      });
  }

  // 图谱缩放相关函数
  const zoomed = (event) => {
    d3.select('#graph').select(".svgBox").attr("transform", "translate(" + event.transform.x + "," + event.transform.y + ") scale(" + event.transform.k + "," + event.transform.k + ")");
  }

  // 求元素移动到目标位置所需要的 transform 属性值
  const getTransform = (source, target, _dis) => {
    let r;
    if (target.x > source.x) {
      if (target.y > source.y) {
        r = Math.asin((target.y - source.y) / _dis)
      } else {
        r = Math.asin((source.y - target.y) / _dis);
        r = -r;
      }
    } else {
      if (target.y > source.y) {
        r = Math.asin((target.y - source.y) / _dis);
        r = Math.PI - r;
      } else {
        r = Math.asin((source.y - target.y) / _dis);
        r -= Math.PI;
      }
    }
    r = r * (180 / Math.PI);
    return "translate(" + source.x + "," + source.y + ")rotate(" + r + ")";
  }

  // 求两点间的距离
  const getDis = (s, t) => {
    return Math.sqrt((s.x - t.x) * (s.x - t.x) + (s.y - t.y) * (s.y - t.y));
  }

  // 图谱拖拽相关函数
  const drag = (simulation) => {
    function dragstarted(d) {
      if (!d.active) simulation.alphaTarget(0.3).restart();
      d.subject.fx = d.subject.x;
      d.subject.fy = d.subject.y;
      // console.log(d)
    }

    function dragged(d) {
      d.subject.fx = d.x;
      d.subject.fy = d.y;
      // console.log(d)
    }

    function dragended(d) {
      if (!d.active) simulation.alphaTarget(0);
      d.subject.fx = null;
      d.subject.fy = null;
      d.fixed = false;
    }
    return d3.drag()
      .on("start", dragstarted)
      .on("drag", dragged)
      .on("end", dragended);
  }

  // 清空图谱数据
  const emptyMapDatas = () => {
    d3.select('#graph').select('.arrows').selectAll('marker').remove();
    d3.select('#graph').select('.avatars').selectAll('pattern').remove();
    d3.select('#graph').select('.relMap_g').selectAll('g').remove();
    d3.select('#graph').select('.relMap_g').selectAll('circle').remove();
    d3.select('#graph').select('.relMap_g').selectAll('text').remove();
  }

  return (
    <Modal className='share-modal' visible={isModalOpen} onCancel={handleCancel}>
      <div className='topPart' id='contentModule'>
        <img src={logo1} alt='' />
        {
          (operationType == 1 || operationType == 2) && instance &&
          <>
            <h3>
              <span>{instance?.instanceName}</span>
              {
                operationType == 1 && <a href={"/Subject/null/" + instanceId} target='_blank' className="btn-link instance-link">
                  知识百科
                  <img src={arrow1} />
                </a>
              }
              {
                operationType == 2 && <a href={"/PicturelistPage/" + instanceId + '?fileInfoId=' + fileInfoId} target='_blank' className="btn-link img-link">
                  影像探索
                  <img src={arrow3} />
                </a>
              }
            </h3>
            <div className="content">
              <div className='img'>
                <img src={instance?.showImage ? pre + '/' + instance.showImage : Default}/>
              </div>
              <div className="text">
                {
                  instance?.attrFields?.slice(0, 4).map((item, index) => {
                    let name;
                    instance?.attrTriples.forEach(i => {
                      if (i.englishCode == item) {
                        name = i.relationshipName;
                      }
                    })
                    const val = instance?.properties[item] && htmltoStr(instance?.properties[item]);
                    return (
                      name && val && <p className="attr" key={index}><span>{name}：</span><span className='val'>{val}</span></p>
                    )
                  })}
                {instance?.properties?.description && <p className="desc">{htmltoStr(instance?.properties?.description)}</p>}
              </div>
            </div>
          </>
        }
        <div className={cls('gxtpModule', { show: operationType == 3 })}>
          <h3>
            <span>{startNodeName}和{endNodeName}的关系路径</span>
            <a href={'/Relation?startsearch=' + startNodeName + '&endsearch=' + endNodeName} target='_blank' className="btn-link relation-link">
              关系图谱
              <img src={arrow2} />
            </a>
          </h3>
          <div id='graph' />
        </div>
        <div className='code'>
          <img src={code_icon} />
          <div className='codeText'>
            <span>微信扫一扫</span>
            <span>分享给好友</span>
          </div>
          <div className="codeImg">
            <img src={code_img} />
          </div>
        </div>
      </div>
      <div className='bottomPart'>
        <div className="lianjie" onClick={() => copy()} />
        {
          operationType != 3 && <div className="download" onClick={() => download()} />
        }
        {/* <div className="download" onClick={() => download()} /> */}
        <div className="qq" onClick={() => shareqq()} />
        <div className="weibo" onClick={() => shareweibo()} />
      </div>
    </Modal>
  );
};
export default ShareModal;
